// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {debounce} from '@github/mini-throttle'
import {DEFAULT_RELAY_CACHE_TTL} from '@github-ui/relay-query-cache/helpers'
import {fetchQueryWithCache} from '@github-ui/relay-query-cache/query-helpers'
import type {Environment} from 'relay-runtime'

import type {IssueViewerViewQuery} from './__generated__/IssueViewerViewQuery.graphql'
import {IssueViewerViewGraphqlQuery} from './IssueViewer'

const PREFETCH_ISSUE_DEBOUNCE_MS = 500

// A method that returns a promise to prefetch all issue specific data
export const prefetchIssue = (environment: Environment, owner: string, repo: string, number: number) => {
  return fetchQueryWithCache<IssueViewerViewQuery>(
    environment,
    IssueViewerViewGraphqlQuery,
    {
      owner,
      repo,
      number,
      count: 15,
    },
    {fetchPolicy: 'store-or-network'},
    DEFAULT_RELAY_CACHE_TTL,
  ).toPromise()
}

// Will only execute the last call to prefetchIssueDebounced after not being called for PREFETCH_ISSUE_DEBOUNCE_MS
// Useful to prevent scrolling or moving the mouse across a list of issues triggering a lot of prefetches
export const prefetchIssueDebounced = debounce(prefetchIssue, PREFETCH_ISSUE_DEBOUNCE_MS)
